export enum AssetAcquisionType {
PurchaseInvoice,
Donation,
Expropriation,
Subsidy,
}
